// Table.js
import React from 'react';
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { useTranslation } from 'react-i18next';
// import { ActionRow } from './ActionRow';
import { useState } from 'react';
// import { Form } from 'react-bootstrap';

function TableComp({ data, columnNames, setSortedData, handleSelectAll, isChecked, handleDelete,track, children, page, withoutAction }) {
    const { t } = useTranslation(); // Use t instead of lang
    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('');
    const handleSort = (column) => {
        if (sortColumn === column) {
            const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
            setSortDirection(newSortDirection);
            setSortedData([...data].sort((a, b) => {
                if (newSortDirection === 'asc') {
                    return a[sortColumn] < b[sortColumn] ? 1 : -1;
                } else {
                    return a[sortColumn] > b[sortColumn] ? 1 : -1;
                }
            }));
        } else {
            setSortColumn(column);
            setSortDirection('asc');
            setSortedData([...data].sort((a, b) => a[sortColumn] < b[sortColumn] ? 1 : -1));
        }

    };
    return (
        <div className='w-100 overflow-auto min-h-200'>
        <table id="main-table" className={`main-table mb-4  ${withoutAction && 'table-without-action'}`}>
            <thead>
                <tr>

                  {/* {page !== 'item' && <th scope="col">
                        <Form.Check
                            type='checkbox'
                            name="selectAll"
                            id="selectAll"
                            onChange={handleSelectAll}
                            checked={isChecked}
                        />
                    </th> } */}
                    {columnNames.map((columnName, index) => (
                        <th scope="col" key={columnName} onClick={() => handleSort(columnName)}>
                            {t(columnName)}
                            {sortColumn === columnName ? (
                                sortDirection === 'asc' ? <TiArrowSortedUp color='#4D4C68' /> : <TiArrowSortedDown color='#4D4C68' />
                            ) :
                                <TiArrowSortedDown color='#4D4C68' />}
                        </th>
                    ))}
                    {/* {page !== 'item' && <th scope="col"><ActionRow deleteRow={handleDelete} /></th>} */}
                    {track && <th  onClick={() => handleSort('Tracking')}>{t('Tracking')} {sortDirection === 'asc' ? <TiArrowSortedUp color='#4D4C68' /> : <TiArrowSortedDown color='#4D4C68' />}</th>}
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
            {data.length === 0 && <caption className='noData'>{t('There is no information to display')}.</caption>}

        </table>
        </div>

    );
}


export default TableComp;